/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Self_Organize_Not_SeatedInputs */



/**
* | output |
* | --- |
* | "You must seat yourself in a round you organize" |
*
* @param {Err_Tournament_Self_Organize_Not_SeatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_self_organize_not_seated = /** @type {((inputs?: Err_Tournament_Self_Organize_Not_SeatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Self_Organize_Not_SeatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez vous placer vous-même dans une ronde que vous organisez")
	if (locale === "es") return /** @type {LocalizedString} */ ("Debe asignarse un asiento en la ronda que organiza")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você deve alocar a si mesmo em uma rodada que organizar")
	if (locale === "it") return /** @type {LocalizedString} */ ("È necessario assegnarsi un posto nel round che si organizza")
	return /** @type {LocalizedString} */ ("You must seat yourself in a round you organize")
});